<template>
  <div class="panal mt-20">
    <div class="panal-header">Attachments </div>

    <div class="table-responsive p-3">
      <table class="table table-hover table-bordered">
        <thead class="thead-light">
          <tr>
            <th scope="col" width="20%">View</th>
            <th scope="col" width="30%" colspan="2">Attachment Type</th>
            <th scope="col" width="20%">Upload Date</th>
            <th scope="col" width="20%">Delete</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="empty">
            <td colspan="5"> No Data </td>
          </tr>

          <tr v-else v-for="(Attach) in ApplicantAttachments" v-bind:key="Attach.serial">
            <td>
              <a :href="Attach.FilePathView" target="_blank">View</a>
            </td>
            <td colspan="2">{{Attach.FileAttachmentTypeNameEN}}</td>
            <td>{{Attach.AttachmentDate}}</td>

            <td><button class="btn btn-danger" @click="filedelete(Attach.serial)"><i class=""></i>delete</button></td>
          </tr>

          <tr class="table-borderless">
            <td align="left" colspan="2">
              <span>Attachment Type</span>
              <select class="form-control w-100 su-border" id="exampleFormControlSelect3"
                v-model="FileAttachmentsTypeID">
                <option selected value="0">Choose</option>
                <option v-for="type in FileAttachmentsList" :value="type.serial" v-bind:key="type.serial">
                  {{type.FileAttachmentTypeNameEN}}</option>
              </select>
            </td>
            <td align="left" colspan="2">
              <span class="text-left">Select Document</span>


              <div class="custom-file">
                <input type="file" class="custom-file-input su-border" id="customFile" ref="file"
                  v-on:change="handleFileUpload()" accept=".pdf, .jpg, .png, .jpeg, .gif, .bmp, .tif, .tiff|image/*">
                <label class="custom-file-label" for="customFile">{{file.name ? file.name : "Choose file"}}</label>
                <progress max="100" :value.prop="uploadPercentage" :hidden="!submitted"></progress>
              </div>


            </td>


            <td style="text-align: left;">
              <br />
              <input type="button" class="btn btn-block btn-primary" id="addrow" value="Upload"
                v-on:click="submitFile()" />
            </td>

          </tr>
        </tbody>
      </table>

      <div v-if="message && !empty" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">{{message}}
      </div>

    </div>



  </div>


</template>

<script>
  import Axios from 'axios';
  import ApplicantService from '../../services/Applicant/Applicant.service';
  import {
    AttachmentTypes
  } from '../../models/Applicant';
  import ApplicantDataServices from '../../services/Applicant/ApplicantData.services';
  import {
    API_URL
  } from '../../services/API_URL';
  export default {
    name: 'Attachments',
    data() {
      return {
        file: '',
        uploadPercentage: 0,
        UserID: 2,
        FileAttachmentsTypeID: 0,
        FileAttachmentsList: new AttachmentTypes('', '', ''),
        message: '',
        submitted: false,
        loading: false,
        successful: false,
        ApplicantAttachments: [],
        empty: false,
      }
    },
    computed: {
      currenUser() {
        return this.$store.state.auth.user
      },
      reviewApplication() {
        return this.$store.state.auth.renderReview
      }
    },
    mounted() {
      ApplicantService.GetAttachmentTypes().then(Response => {
        this.FileAttachmentsList = Response.data
      }, error => {

        this.message =
          (error.response && error.response.data) ||
          error.message ||
          error.toString();
      });
      ApplicantDataServices.GetListofApplicantAttachments(this.currenUser.UserIDSerial).then(Response => {
        this.ApplicantAttachments = Response.data
        this.empty = false
      }, error => {

        this.empty = true
        this.successful = false
        this.message =
          (error.response && error.response.data && error.response.data.Message) ||
          error.message ||
          error.toString();
      });

    },
    methods: {
      handleFileUpload() {
        this.file = this.$refs.file.files[0];
        // if(files[0]['type']==='image/jpeg'){};
  //       if(['image/png','image/jpeg','image/svg'].includes(files[0]['type'])){
  //         this.file = this.$refs.file.files[0];
   
  // }
      },
      submitFile() {
        this.submitted = true
        /*
          Initialize the form data
        */
        let formData = new FormData();

        /*
          Add the form data we need to submit
        */
        formData.append('UploadedFile', this.file);
        formData.append('ApplicantID', this.currenUser.UserIDSerial)
        formData.append('FileAttachmentsTypeID', this.FileAttachmentsTypeID)
        formData.append('UserID', this.UserID)


        /*
          Make the request to the POST /single-file URL
        */

        Axios.post(API_URL + '/FileAttachments/FileAttachment_Insert',
            formData, {
              headers: {
                'Content-Type': 'multipart/form-data'
              },
              onUploadProgress: function (progressEvent) {
                this.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
              }.bind(this)
            }
          ).then(error => {
            this.submitted = false
            this.uploadPercentage = 0
            this.FileAttachmentsTypeID = 0

            ApplicantDataServices.GetListofApplicantAttachments(this.currenUser.UserIDSerial).then(Response => {
              this.ApplicantAttachments = Response.data
              this.empty = false
              this.$store.dispatch('auth/Review', this.reviewApplication + 1)

            })
            this.successful = true
            this.empty = true
            this.message =
              (error.response && error.response.data && error.response.data.Message) ||
              error.message || error.data ||
              error.toString();
          })
          .catch(error => {

            this.empty = false;
            this.successful = false
            this.submitted = false
            this.uploadPercentage = 0
            this.FileAttachmentsTypeID = 0
            this.message =
              (error.response && error.response.data && error.response.data.Message) ||
              error.Message ||
              error.toString();

          });
      },

      filedelete(FileSerial) {
        ApplicantDataServices.ApplicantAttachmentDelete(this.currenUser.UserIDSerial, FileSerial).then(Response => {
          this.message = Response.data
          this.successful = true

          this.ApplicantAttachments = this.ApplicantAttachments.filter(files => files.serial != FileSerial)
          this.empty = false
        }, error => {
          this.empty = false
          this.successful = false
          this.message =
            (error.response && error.response.data && error.response.data.Message) ||
            error.message ||
            error.toString();
        });
      }
    }

  }
</script>

<style scoped>
  .panal {
    background: #fff;
    border-radius: 10px;
    color: #fff;
    padding: 0px 0px 20px 0px;
    margin-bottom: 20px !important;
  }

  .panal {
    background: #fff;
    border-radius: 10px;
    color: #fff;
    padding: 0px 0px 20px 0px;
    -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;

  }

  .panal-header {
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
    width: 50%;
    /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
  }

  .mt-20 {
    margin-top: 20px;
  }

  .mt-40 {
    margin-top: 40px;
  }

  th {
    font-weight: bold;
  }

  .su-border {
    border-color: #3D8FE3 !important;
    background: #F1F9FF !important;
  }
</style>